import { render, staticRenderFns } from "./PopupTemperature.vue?vue&type=template&id=19f97d36&"
import script from "./PopupTemperature.vue?vue&type=script&lang=js&"
export * from "./PopupTemperature.vue?vue&type=script&lang=js&"
import style0 from "./PopupTemperature.vue?vue&type=style&index=0&id=19f97d36&prod&lang=scss&"
import style1 from "./PopupTemperature.vue?vue&type=style&index=1&id=19f97d36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports